export default __webpack_public_path__ + "media/images/new_year/header_1280x840-d91417f2f0eb85eade0d9830f67f9530.webp";